$(document).ready(function () {
  var $sliderEl = $('[data-article-slider]');
  if ($sliderEl.length && typeof $.fn.flickity !== 'undefined') {
    var slider = $sliderEl.flickity({
      imagesLoaded: true,
      draggable: true,
      cellAlign: 'left',
      cellSelector: '.featured-article',
      wrapAround: true,
      pageDots: true,
      contain: true,
      prevNextButtons: true,
      initialIndex: 0
    });

    $sliderEl.on('settle.flickity', function () {
      setTimeout(function () {
        $sliderEl.addClass('flickity-slider-ready');
      }, 300);
    });

    $sliderEl.on('settle.flickity', function () {
      $sliderEl.flickity('resize');
    });
  }
});

$(document).ready(function () {
  var $sliderEl = $('.tablet-slider-enable .blog-post-container');
  var flktyInstance = null;
  function initSlider() {
    if ($(window).width() <= 992) {
      if ($sliderEl.hasClass('flickity-enabled')) return;
      if ($sliderEl.length && typeof $.fn.flickity !== 'undefined') {

        flktyInstance = $sliderEl.flickity({
          imagesLoaded: true,
          draggable: true,
          cellAlign: 'left',
          cellSelector: '.featured-article',
          wrapAround: false,
          pageDots: true,
          contain: true,
          prevNextButtons: false,
          initialIndex: 0
        });

        $sliderEl.on('settle.flickity', function () {
          setTimeout(function () {
            $sliderEl.addClass('flickity-slider-ready');
          }, 300);
        });

        $sliderEl.on('settle.flickity', function () {
          $sliderEl.flickity('resize');
        });
      }
    } else {
      if ($sliderEl.hasClass('flickity-enabled')) {
        $sliderEl.flickity('destroy');
        $sliderEl.removeClass('flickity-slider-ready');
      }
    }
  }

  initSlider();

  var resizeTimer;
  $(window).on('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      initSlider();
    }, 200);
  });
});